import {HttpStatusCode} from '@shared/helpers/api'

import {getGwErrorMessage} from '@web/helpers/api'

export const parseServiceUnavailableError = (error: unknown) => {
    const gatewayError =
        !!error &&
        typeof error === 'string' &&
        getGwErrorMessage<{
            code: string
            message: string
            body: {code?: string; message?: string; additionalMessage?: string}
        }>(error)

    if (gatewayError && gatewayError.status === HttpStatusCode.ServiceUnavailable) {
        return gatewayError.data.result
    }

    return null
}
